/**
 * The ship views as a service (M10 P1a1): provides `ctx.views` under `shipViews`, so debug and later features reach
 * the views (`assetOf`, the live view of an entity) without a `boot.ts` edit. Every mode; nothing per frame.
 */
import { FEATURE_ORDER, type GameContext, type GameFeature } from '../../app/feature'
import type { ShipViews } from '../../render/shipViews'

declare module '../../app/services' {
  interface ServiceMap {
    shipViews: ShipViews
  }
}

/** First of all: right after the camera (100), before the career (150). */
const ORDER = FEATURE_ORDER.camera + 1

const feature: GameFeature = {
  name: 'shipViews',
  order: ORDER,
  init(ctx: GameContext): void {
    ctx.services.provide('shipViews', ctx.views)
  },
}

export default feature
